// extracted by mini-css-extract-plugin
export default {"loader":"PageLoader_loader__YaQY8","loader__bar":"PageLoader_loader__bar__NBEtn","loaderbar":"PageLoader_loaderbar__Juinb","spinner":"PageLoader_spinner__I86hF"};